export default __webpack_public_path__ + "static/media/performance-green1.c3da54f6.svg";